// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingIndicator_loading__iwnaR"};